import React, { useMemo, useState } from 'react';
import { useAvailableServicesQuery } from '../../../../../../graphql/graphql';
import Loading from '../../../../../../Components/Loading';
import styles from './ManagerServicesList.module.scss';
import Text from '../../../../../../Components/Base/Text/Text';
import { Theme } from '../../../../../../Enums/Theme.enum';
import ManagerHookUpCSSZModal from './ManagerHookUpCSSZModal';
import ManagerHookUpSUKLModal from './ManagerHookUpSUKLModal';
import ManagerHookUpCSSZSickLeaveModal from './ManagerHookUpCSSZSickLeaveModal';
import ManagerHookUpInsuranceBatchInvoiceModal from './ManagerHookUpInsuranceBatchInvoiceModal';
import LinkButton from '../../../../../../Components/Button/LinkButton';
import { isAllowed } from '../../../../../../Services/acl.service';

const ManagerServicesList: React.FC = () => {
	const [isCSSZOpen, setIsCSSZOpen] = useState(false);
	const [isCSSZSickLeaveOpen, setIsCSSZSickLeaveOpen] = useState(false);
	const [isSUKLOpen, setIsSUKLOpen] = useState(false);
	const [isInsuranceBatchInvoiceOpen, setIsInsuranceBatchInvoiceOpen] =
		useState(false);

	const { data, isLoading } = useAvailableServicesQuery();
	const canManageSickLeaves = isAllowed('manager_sick_leaves');

	const services: {
		cssz: boolean;
		sukl: boolean;
		csszSickLeave: boolean;
		insuranceBatchInvoice: boolean;
	} = useMemo(() => {
		if (data) {
			const termItems = data?.termItems?.data;
			return {
				cssz: termItems?.some(item => item?.value === 'csszAddress') || false,
				sukl: termItems?.some(item => item?.value === 'eErecept') || false,
				csszSickLeave:
					termItems?.some(item => item?.value === 'csszSickLeave') || false,
				insuranceBatchInvoice:
					termItems?.some(item => item?.value === 'insuranceBatchInvoice') ||
					false,
			};
		}

		return {
			cssz: false,
			sukl: false,
			csszSickLeave: false,
			insuranceBatchInvoice: false,
		};
	}, [data]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<>
			<div className={styles.wrapper}>
				{services.cssz && (
					<div className={styles.item}>
						<div>
							<Text className={styles.title} tx='component.hookUp.cssz.text' />
							<Text
								className={styles.description}
								tx='component.hookUp.cssz.hint'
							/>
						</div>
						<div>
							<LinkButton
								theme={Theme.BLUE}
								title='base.settings'
								onClick={() => setIsCSSZOpen(true)}
								firstUpper
							/>
						</div>
					</div>
				)}
				{services.sukl && (
					<div className={styles.item}>
						<div>
							<Text className={styles.title} tx='component.hookUp.sukl.text' />
							<Text
								className={styles.description}
								tx='component.hookUp.sukl.hint'
							/>
						</div>
						<div>
							<LinkButton
								theme={Theme.BLUE}
								title='base.settings'
								onClick={() => setIsSUKLOpen(true)}
								firstUpper
							/>
						</div>
					</div>
				)}
				{canManageSickLeaves && services.csszSickLeave && (
					<div className={styles.item}>
						<div>
							<Text
								className={styles.title}
								tx='component.hookUp.csszSickLeave.text'
							/>
							<Text
								className={styles.description}
								tx='component.hookUp.csszSickLeave.hint'
							/>
						</div>
						<div>
							<LinkButton
								theme={Theme.BLUE}
								title='base.settings'
								onClick={() => setIsCSSZSickLeaveOpen(true)}
								firstUpper
							/>
						</div>
					</div>
				)}
				{services.insuranceBatchInvoice && (
					<div className={styles.item}>
						<div>
							<Text
								className={styles.title}
								tx='component.hookUp.insuranceBatchInvoice.text'
							/>
							<Text
								className={styles.description}
								tx='component.hookUp.insuranceBatchInvoice.hint'
							/>
						</div>
						<div>
							<LinkButton
								theme={Theme.BLUE}
								title='base.settings'
								onClick={() => setIsInsuranceBatchInvoiceOpen(true)}
								firstUpper
							/>
						</div>
					</div>
				)}
			</div>
			{isCSSZOpen && (
				<ManagerHookUpCSSZModal
					isOpen
					onClose={() => setIsCSSZOpen(false)}
					onSave={() => setIsCSSZOpen(false)}
				/>
			)}
			{isSUKLOpen && (
				<ManagerHookUpSUKLModal
					isOpen
					onClose={() => setIsSUKLOpen(false)}
					onSave={() => setIsSUKLOpen(false)}
				/>
			)}
			{isCSSZSickLeaveOpen && (
				<ManagerHookUpCSSZSickLeaveModal
					isOpen
					onSave={() => setIsCSSZSickLeaveOpen(false)}
					onClose={() => setIsCSSZSickLeaveOpen(false)}
				/>
			)}
			{isInsuranceBatchInvoiceOpen && (
				<ManagerHookUpInsuranceBatchInvoiceModal
					isOpen
					onSubmit={() => setIsInsuranceBatchInvoiceOpen(false)}
					onClose={() => setIsInsuranceBatchInvoiceOpen(false)}
				/>
			)}
		</>
	);
};

export default ManagerServicesList;
